<script>

export default {
  props: ['replacefilters', 'changefilters'],
  data() {
    return {
      dsbl_btn: false,
      show_filters: false,
      changes: false,

      isCheckAll: false,

      search: '',
      lives: [
        {value: '1', name: 'Live'},
        {value: '0', name: 'Not live'},
        {value: '', name: 'Live and Not live'},
      ],
      unseens: [
        {value: '1', name: 'Unseen'},
        {value: '0', name: 'Seen'},
        {value: '', name: 'Unseen and Seen'},
      ],
      importants: [
        {value: '1', name: 'Important'},
        {value: '0', name: 'Not Important'},
        {value: '', name: 'Important and Not Important'},
      ],
      dateRange: { startDate: null, endDate: null },

      loading: true,
      results: [],
      pagination: {},
      filters: {
        paginate: 50,
        page: 1,
        total: 0,
        betweens: {
          created_at: {
            start: '',
            end: ''
          }
        },
        wheres: {
          status: '',
        },
        whereins: {
          website: [],
        },
        searchs: {
          search1: {
            value: ''
          }
        },
        orderbys: {
          
        },
      },
    }
  },
  computed: {
    areChecked: function () { for(var i in this.results) { if(this.results[i].selected == true){ return true; } } return false; }
  },
  watch: {
    'dateRange': { handler: function(n, o) {
      console.log('Date changed');
      if(n.startDate && n.endDate && this.moment(n.startDate).isValid() && this.moment(n.endDate).isValid()) {
        this.filters.betweens.created_at.start = this.moment(n.startDate).startOf('day').format();
        this.filters.betweens.created_at.end = this.moment(n.endDate).endOf('day').format();
      } else {
        this.filters.betweens.created_at.start = '';
        this.filters.betweens.created_at.end = '';
      }
    }, deep: true },

    '$route.params.id': function (id) { if(!id) { console.log("Route param changed. Updating"); this.fetchData(); } },

    'loading': { handler: function(n, o) { this.$emit('loadchange', n) }},

    'filters.paginate': { handler: function(n, o) { this.pagination.current_page = 1; this.fetchData(); }},
  },
  created() {
    if(this.replacefilters) {
      this.filters = this.replacefilters;
    } else if(this.changefilters) {
      for(var i in this.changefilters) {
        this.filters[i] = this.changefilters[i];
      }
    }

    this.fetchData();
  },
  mounted() {
    window.addEventListener('scroll', this.setStickyNav);
    window.addEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').addEventListener('scroll', this.setStickyNav); }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.setStickyNav);
    window.removeEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').removeEventListener('scroll', this.setStickyNav); }
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.filters.page = this.pagination.current_page;
      this.$http.get('/api/inbox/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        this.results = res.data.data;
        this.pagination = res.data;
        this.filters.total = res.data.total;
        this.isCheckAll = false; for(var i in this.results) { this.$set(this.results[i],'selected',false); }
        this.loading = false;
        this.changes = false;
      }).catch(res => { this.loading = false; this.popupErrors(res); });
    },
    checkAll()  {
      for(var i in this.results) {
        if(this.isCheckAll) {
          this.$set(this.results[i],'selected',true);
        } else {
          this.$set(this.results[i],'selected',false);
        }
      }
    },
    toggleImportant(id, subject, important)  {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.put('/api/inbox/update', {id: id, subject: subject, important: important}).then(res => {
        // console.log(res);
        this.fetchData();
        this.dsbl_btn = false;
      }).catch(res => { this.dsbl_btn = false; this.popupErrors(res); });
    },
    massUpdate(act) {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      var ids = []; for(var i in this.results) { if(this.results[i].selected) { ids.push(this.results[i].id); } }
      this.$http.put('/api/inbox/mass', {ids: ids, act: act}).then(res => {
        // console.log(res);
        this.fetchData();
        this.dsbl_btn = false;
      }).catch(res => { this.dsbl_btn = false; this.popupErrors(res); });
    },
  }
}
</script>

<template>
  <div>
    
    <transition name="fade">
      <div class="ribbon-two ribbon-two-primary" :key="1" v-if="loading"><span><i class="spinner-border spinner-border-sm"></i></span></div>
    </transition>
    <div class="px-4 pt-4 pb-3">
      <div class="row">
        <div class="col-lg-8">
          <div class="form-inline">
            <button type="button" @click="fetchData()" class="btn btn-light mr-2 mb-2"><Icon icon="ri:refresh-line"></Icon></button>
            <div class="form-group mr-2 mb-2">
              <input type="text" class="form-control" placeholder="Search..." v-model="filters.searchs.search1.value" @change="changes = true">
            </div>
            <w-field class="mr-2 mb-2" SimpleDataType="String List, Multi" :Options="app_website_ids" v-model="filters.whereins.website" placeholder="Websites..." @input="changes = true"></w-field>
            <div class="form-group mr-2 mb-2">
              <button type="button" class="btn btn-primary dropdown-toggle" @click="show_filters ? show_filters = false : show_filters = true">Filters
                <Icon v-if="show_filters" icon="ri:arrow-drop-down-line"></Icon>
                <Icon v-else icon="ri:arrow-drop-right-line"></Icon>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="text-lg-right mt-3 mt-lg-0">
            
          </div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div v-if="show_filters" class="form-inline px-2 pt-2 bg-gray-200">

        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="String List, Single" v-model="filters.wheres.status" :Options="lives" placeholder="Filter by live..." @input="changes = true"></w-field>
        </div>

        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="String List, Single" v-model="filters.wheres.unseen" :Options="unseens" placeholder="Filter by seen..." @input="changes = true"></w-field>
        </div>
        
        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="String List, Single" v-model="filters.wheres.important" :Options="importants" placeholder="Filter by important..." @input="changes = true"></w-field>
        </div>

        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="Date range" v-model="dateRange" placeholder="Filter by date created..." @input="changes = true"></w-field>
        </div>

        <div class="form-group mr-2 mb-2">
          <select class="form-control" v-model="filters.paginate">
            <option value="50">Per page: (50)</option>
            <option value="100">Per page: (100)</option>
            <option value="250">Per page: (250)</option>
            <option value="500">Per page: (500)</option>
            <option value="750">Per page: (750)</option>
            <option value="1000">Per page: (1000)</option>
          </select>
        </div>

      </div>
    </transition>
    <transition name="fade">
      <div v-if="changes" class="alert alert-info rounded-0 m-0">Click <Icon icon="ri:refresh-line" /> commit any changes made to filters.</div>
    </transition>
    <div class="row">
      <div class="col-sm-12">
        <div class="table-responsive m-0">
          <table class="table table-small sticky-header table-bordered-right table-hover mb-0 table-centered text-nowrap">
            <thead class="bg-white">
              <tr>
                <th class="px-3 py-2 _w-50">
                  <w-field class="m-0 _f-s-17" SimpleDataType="Boolean" v-model="isCheckAll" Color="success" @input="checkAll()" :disabled="dsbl_btn"></w-field>
                </th>
                <th class="_w-50 position-relative">
                  <div class="position-absolute _pos-t-0 _pos-l-0 _pos-b-0 bg-white overflow-hidden">
                    <transition name="slideLeft" tag="div" mode="out-in">
                      <div v-if="areChecked" key="zde" class="mt-1 py-2 pl-1">
                        <span class="mx-2" v-tippy content="Mark selected as not important" :class="dsbl_btn ? '' : '_c-pointer'" @click="dsbl_btn ? '' : massUpdate('unimportant')"><Icon icon="ri:star-line" width="20" /></span>
                        <span class="mx-2" v-tippy content="Mark selected as important" :class="dsbl_btn ? '' : '_c-pointer'" @click="dsbl_btn ? '' : massUpdate('important')"><Icon icon="ri:star-fill" width="20" /></span>
                        <span class="mx-2" v-tippy content="Mark selected as seen" :class="dsbl_btn ? '' : '_c-pointer'" @click="dsbl_btn ? '' : massUpdate('seen')"><Icon icon="ri:eye-line" width="20" /></span>
                        <span class="mx-2" v-tippy content="Mark selected as unseen" :class="dsbl_btn ? '' : '_c-pointer'" @click="dsbl_btn ? '' : massUpdate('unseen')"><Icon icon="ri:eye-fill" width="20" /></span>
                        <span class="mx-2" v-tippy content="Delete all selected" :class="dsbl_btn ? '' : '_c-pointer'" @click="dsbl_btn ? '' : massUpdate('delete')"><Icon icon="ri:delete-bin-7-line" width="20" /></span>
                      </div>
                    </transition>
                  </div>
                </th>
                <th><tdsort coltext="From" :orderby.sync="filters.orderbys.name" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Subject" :orderby.sync="filters.orderbys.subject" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Email address" :orderby.sync="filters.orderbys.email" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Phone number" :orderby.sync="filters.orderbys.phone" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Website" :orderby.sync="filters.orderbys.website" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="IP address" :orderby.sync="filters.orderbys.ip_address" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Updated on" :orderby.sync="filters.orderbys.updated_at" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Created on" :orderby.sync="filters.orderbys.created_at" @do="fetchData()"></tdsort></th>
              </tr>
              <tr class="sticky-thead bg-white">
                <th class="px-3 py-2 _w-50">
                  <w-field class="m-0 _f-s-17" SimpleDataType="Boolean" v-model="isCheckAll" Color="success" @input="checkAll()" :disabled="dsbl_btn"></w-field>
                </th>
                <th class="_w-50 position-relative">
                  <div class="position-absolute _pos-t-0 _pos-l-0 _pos-b-0 bg-white overflow-hidden">
                    <transition name="slideLeft" tag="div" mode="out-in">
                      <div v-if="areChecked" key="zde" class="mt-1 py-2 pl-1">
                        <span class="mx-2" v-tippy content="Mark selected as not important" :class="dsbl_btn ? '' : '_c-pointer'" @click="dsbl_btn ? '' : massUpdate('unimportant')"><Icon icon="ri:star-line" width="20" /></span>
                        <span class="mx-2" v-tippy content="Mark selected as important" :class="dsbl_btn ? '' : '_c-pointer'" @click="dsbl_btn ? '' : massUpdate('important')"><Icon icon="ri:star-fill" width="20" /></span>
                        <span class="mx-2" v-tippy content="Mark selected as seen" :class="dsbl_btn ? '' : '_c-pointer'" @click="dsbl_btn ? '' : massUpdate('seen')"><Icon icon="ri:eye-line" width="20" /></span>
                        <span class="mx-2" v-tippy content="Mark selected as unseen" :class="dsbl_btn ? '' : '_c-pointer'" @click="dsbl_btn ? '' : massUpdate('unseen')"><Icon icon="ri:eye-fill" width="20" /></span>
                        <span class="mx-2" v-tippy content="Delete all selected" :class="dsbl_btn ? '' : '_c-pointer'" @click="dsbl_btn ? '' : massUpdate('delete')"><Icon icon="ri:delete-bin-7-line" width="20" /></span>
                      </div>
                    </transition>
                  </div>
                </th>
                <th><tdsort coltext="From" :orderby.sync="filters.orderbys.name" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Subject" :orderby.sync="filters.orderbys.subject" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Email address" :orderby.sync="filters.orderbys.email" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Phone number" :orderby.sync="filters.orderbys.phone" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Website" :orderby.sync="filters.orderbys.website" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="IP address" :orderby.sync="filters.orderbys.ip_address" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Updated on" :orderby.sync="filters.orderbys.updated_at" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Created on" :orderby.sync="filters.orderbys.created_at" @do="fetchData()"></tdsort></th>
              </tr>
            </thead>
            <tbody class="">
              <tr v-for="(item, index) in results" :key="item.id" class="_c-pointer" exact :class="item.unseen ? 'border-left _b-s-3 border-primary font-weight-bold' : ''">
                <td class="px-3 py-2">
                  <w-field class="m-0 _f-s-17" SimpleDataType="Boolean" v-model="item.selected" Color="success" :disabled="dsbl_btn"></w-field>
                </td>
                <td class="py-2">
                  <span v-if="item.important" class="text-warning" v-tippy content="Mark selected as not important" :class="dsbl_btn ? '' : '_c-pointer'" @click="dsbl_btn ? '' : toggleImportant(item.id, item.subject, 0)"><Icon icon="ri:star-fill" width="20" /></span>
                  <span v-else v-tippy content="Mark selected as important" :class="dsbl_btn ? '' : '_c-pointer'" @click="dsbl_btn ? '' : toggleImportant(item.id, item.subject, 1)"><Icon icon="ri:star-line" width="20" /></span>
                </td>
                <td class="text-dark p-0">
                  <router-link :to="'/inbox/'+item.id" tag="a" class="text-dark d-block p-3" exact>
                    <span v-if="item.name">{{item.name}}</span><span v-else>{{item.email}}</span>
                  </router-link>
                </td>
                <td class="p-0"><router-link :to="'/inbox/'+item.id" tag="a" class="text-dark d-block p-3" exact>{{item.subject}}</router-link></td>
                <td class="p-0"><router-link :to="'/inbox/'+item.id" tag="a" class="text-dark d-block p-3" exact>{{item.email}}</router-link></td>
                <td class="p-0"><router-link :to="'/inbox/'+item.id" tag="a" class="text-dark d-block p-3" exact>{{ formatPhone(item.phone) }}</router-link></td>
                <td class="p-0">{{item.website}}</td>
                <td class="p-0"><router-link :to="'/inbox/'+item.id" tag="a" class="text-dark d-block p-3" exact>{{item.ip_address}}</router-link></td>
                <td class="p-0" v-tippy :content="moment(item.updated_at).format('lll')"><router-link :to="'/inbox/'+item.id" tag="a" class="text-dark d-block p-3" exact>{{moment(item.updated_at).fromNow()}}</router-link></td>
                <td class="p-0" v-tippy :content="moment(item.created_at).format('lll')"><router-link :to="'/inbox/'+item.id" tag="a" class="text-dark d-block p-3" exact>{{moment(item.created_at).fromNow()}}</router-link></td>
              </tr>
            </tbody>
          </table>
          <div class="p-3 border-top border-light">
            <w-pagination :pagination="pagination" @paginate="results=[]; fetchData()" :offset="4"></w-pagination>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
